import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	applyOldListSettings: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyOldListSettingsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyOldListSettingsCurrentSpace: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyOldListSettingsCurrentSpaceFallback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyOldListSettingsAllSpaces: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyOldListSettingsCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	applyOldListSettingsApply: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionsOptOutDisplayText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionsGiveFeedbackDisplayText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleDetailsContactSupport: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTypePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bulkChangeIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewIssuesAsAChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewWorkItemsAsAChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	export: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	newLozengeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionsOptOutDisplayTextIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	feedbackTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	formatRules: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	keyboardNavigation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	applyOldListSettings: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings',
		// eslint-disable-next-line jira/i18n/sentence-case-messages
		defaultMessage: 'Apply settings from the old List view',
		description: 'Text for the option to apply old list settings in the meatball menu',
	},
	applyOldListSettingsDescription: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings-description',
		defaultMessage: "This includes the filters, groups, and columns you've set",
		description: 'Helper message for the option to apply old list settings in the meatball menu',
	},
	applyOldListSettingsCurrentSpace: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings-current-space',
		defaultMessage: 'Apply settings from {spaceName} space',
		description:
			'Text for option to apply old list settings from current space in apply old list settings modal',
	},
	applyOldListSettingsCurrentSpaceFallback: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings-current-space-fallback',
		defaultMessage: 'current',
		description:
			'Fallback text that appears in place of space name in apply old list settings modal',
	},
	applyOldListSettingsAllSpaces: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings-all-spaces',
		defaultMessage: 'Yes, apply settings from all Jira spaces',
		description:
			'Text for option to apply old list settings from all spaces in apply old list settings modal',
	},
	applyOldListSettingsCancel: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings-cancel',
		defaultMessage: 'Cancel',
		description: 'Text for the cancel button in the apply old list settings modal',
	},
	applyOldListSettingsApply: {
		id: 'issue-navigator-action-meatball-menu.apply-old-list-settings-apply',
		defaultMessage: 'Apply',
		description:
			'Text for the apply button to confirm selection in the apply old list settings modal',
	},
	moreActionsLabel: {
		id: 'issue-navigator-action-meatball-menu.more-actions-label',
		defaultMessage: 'More actions',
		description: 'Accessibility label of the meatball menu button.',
	},
	actionsOptOutDisplayText: {
		id: 'issue-navigator-action-meatball-menu.actions-opt-out-display-text',
		defaultMessage: 'Go back to the old issue search',
		description: 'meatball menu item display text for opt out of NIN',
	},
	actionsGiveFeedbackDisplayText: {
		id: 'issue-navigator-action-meatball-menu.actions-give-feedback-display-text',
		defaultMessage: 'Give feedback',
		description: 'meatball menu item display text giving feedback for NIN',
	},
	feedbackTitle: {
		id: 'issue-navigator-action-meatball-menu.feedback-title',
		defaultMessage: 'Give feedback for issue search',
		description:
			'Title of the modal dialog where users can share feedback about the issue search experience',
	},
	feedbackTitleDetails: {
		id: 'issue-navigator-action-meatball-menu.feedback-title-details',
		defaultMessage: 'Let us know how we can improve this experience.',
		description:
			'Description of a modal dialog where users can leave feedback for the issue search experience',
	},
	feedbackTitleDetailsContactSupport: {
		id: 'issue-navigator-action-meatball-menu.feedback-title-details-contact-support',
		defaultMessage: 'If you’re having technical issues, contact our support team.',
		description:
			'Message hinting the user to contact the support team if they are trying to report a bug from a feedback dialog',
	},
	feedbackTypePlaceholder: {
		id: 'issue-navigator-action-meatball-menu.feedback-type-placeholder',
		defaultMessage: 'Select an option',
		description: 'Placeholder of the dropdown component where users can select a feedback category',
	},
	bulkChangeIssues: {
		id: 'issue-navigator-action-meatball-menu.bulk-change-issues',
		defaultMessage: 'Bulk change work items',
		description: 'Text for the bulk change issues link in the meatball menu',
	},
	viewIssuesAsAChart: {
		id: 'issue-navigator-action-meatball-menu.view-issues-as-a-chart',
		defaultMessage: 'View issues as a chart',
		description:
			'Dropdown item to open a sidebar allowing users to visualise their issues as a chart',
	},
	viewWorkItemsAsAChart: {
		id: 'issue-navigator-action-meatball-menu.view-issues-as-a-chart-issue-term-refresh',
		defaultMessage: 'View work items as a chart',
		description:
			'Dropdown item to open a sidebar allowing users to visualise their work items as a chart',
	},
	export: {
		id: 'issue-navigator-action-meatball-menu.export',
		defaultMessage: 'Export',
		description: 'Text for the export option in the meatball menu',
	},
	newLozengeLabel: {
		id: 'issue-navigator-action-meatball-menu.new-lozenge-label',
		defaultMessage: 'New',
		description:
			'Label for a lozenge indicating an item in the meatball menu is new, for discoverability purposes.',
	},
	actionsOptOutDisplayTextIssueTerminologyRefreshM4: {
		id: 'issue-navigator-action-meatball-menu.actions-opt-out-display-text-issue-terminology-refresh-m4',
		defaultMessage: 'Go back to the old search',
		description: 'meatball menu item display text for opt out of NIN',
	},
	feedbackTitleIssueTerminologyRefreshM4: {
		id: 'issue-navigator-action-meatball-menu.feedback-title-issue-terminology-refresh-m4',
		defaultMessage: 'Give feedback for the search',
		description:
			'Title of the modal dialog where users can share feedback about the issue search experience',
	},
	formatRules: {
		id: 'issue-navigator-action-meatball-menu.formatRules',
		defaultMessage: 'Format rules',
		description:
			'Label for dropdown item in meatball menu to open up conditional formatting sidebar',
	},
	keyboardNavigation: {
		id: 'issue-navigator-action-meatball-menu.keyboard-navigation',
		defaultMessage: 'Keyboard navigation',
		description:
			'Label for dropdown item in meatball menu to open up keyboard navigation help article',
	},
});
export default messages;
